export type FaqItem = { question: string; answer: string };

export function FaqSection({
  eyebrow = "FAQ",
  title = "Common questions",
  items,
}: {
  eyebrow?: string;
  title?: string;
  items: FaqItem[];
}) {
  return (
    <section className="relative py-12 sm:py-16 md:py-20">
      <div className="mx-auto max-w-4xl px-5 sm:px-6">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">{eyebrow}</p>
        <h2 className="mt-3 text-3xl md:text-4xl font-bold text-foreground">{title}</h2>
        <dl className="mt-8 space-y-3 sm:mt-10 sm:space-y-4">
          {items.map((item) => (
            <div
              key={item.question}
              className="rounded-lg border border-border/60 bg-card/40 p-5 backdrop-blur-sm sm:rounded-xl sm:p-6"
            >
              <dt className="text-lg font-semibold text-foreground">{item.question}</dt>
              <dd className="mt-2 text-muted-foreground leading-relaxed">{item.answer}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}

export function faqSchemaScript(items: FaqItem[]) {
  return {
    type: "application/ld+json",
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: items.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: { "@type": "Answer", text: item.answer },
      })),
    }),
  };
}
